import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "en-tete" }
const _hoisted_2 = { class: "bandeau" }
const _hoisted_3 = {
  key: 0,
  class: "container-title-icon"
}
const _hoisted_4 = ["alt", "src"]
const _hoisted_5 = { class: "partner" }
const _hoisted_6 = ["alt", "src"]
const _hoisted_7 = { class: "container-menu-account" }
const _hoisted_8 = ["aria-pressed"]
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 2,
  class: "bouton-avec-regle"
}
const _hoisted_11 = {
  key: 3,
  class: "bouton-avec-regle"
}
const _hoisted_12 = ["aria-expanded", "aria-label"]
const _hoisted_13 = { class: "container-dropdown" }
const _hoisted_14 = { class: "content-dropdown" }
const _hoisted_15 = { class: "login-user" }
const _hoisted_16 = ["alt", "src"]
const _hoisted_17 = ["aria-expanded", "aria-label"]
const _hoisted_18 = ["alt", "src"]
const _hoisted_19 = ["alt", "src"]
const _hoisted_20 = {
  key: 7,
  class: "language-flags-container"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "float-right" }
const _hoisted_23 = ["alt", "src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BorderedIconButton = _resolveComponent("BorderedIconButton")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_RoundedIconAndText = _resolveComponent("RoundedIconAndText")!
  const _component_OptionSuiviModale = _resolveComponent("OptionSuiviModale")!
  const _component_PreavisInterventionModale = _resolveComponent("PreavisInterventionModale")!
  const _component_MonCompteModale = _resolveComponent("MonCompteModale")!
  const _component_AppInfoModale = _resolveComponent("AppInfoModale")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.modaleChoixLangueOuverte)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "mainContainer-langue-nav",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.ouvrirFermerModaleChoixLangue && _ctx.ouvrirFermerModaleChoixLangue(...args)))
        }))
      : _createCommentVNode("", true),
    (this.showMyAccountMenu)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "mainContainer-nav",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeNav && _ctx.closeNav(...args)))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.connected)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("img", {
                alt: _ctx.$t('alt.logo.entreprise'),
                src: _ctx.loadIcon,
                class: "icon-portail"
              }, null, 8, _hoisted_4),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logos, (logo) => {
                  return (_openBlock(), _createElementBlock("img", {
                    key: logo.id,
                    alt: _ctx.$t('alt.partenaire', { nom: logo.id }),
                    src: logo.src,
                    class: "icon"
                  }, null, 8, _hoisted_6))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.connected && _ctx.envActuel && _ctx.envActuel.toUpperCase() !== 'PROD')
            ? (_openBlock(), _createBlock(_component_BorderedIconButton, {
                key: 0,
                id: "bouton-app-info",
                className: 'header-button',
                imgUrl: _ctx.loadIconAppInfo,
                onClick: _ctx.openAppInfoModale,
                title: _ctx.envActuel,
                class: "bandeau-button"
              }, null, 8, ["imgUrl", "onClick", "title"]))
            : _createCommentVNode("", true),
          (_ctx.connected && _ctx.autoriseReglesGestion)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                id: "bouton-regles-gestion",
                "aria-pressed": _ctx.reglesGestionActif,
                class: "regles-gestion-toggle",
                type: "button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.basculerReglesGestion && _ctx.basculerReglesGestion(...args)))
              }, [
                _createElementVNode("img", {
                  alt: '',
                  src: _ctx.loadIconReglesGestion,
                  class: "regles-gestion-toggle__icone"
                }, null, 8, _hoisted_9),
                _cache[9] || (_cache[9] = _createElementVNode("span", null, "Règles de gestion", -1))
              ], 8, _hoisted_8))
            : _createCommentVNode("", true),
          (_ctx.connected && _ctx.isPortailClient)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                _createVNode(_component_BorderedIconButton, {
                  id: "bouton-demande-devis",
                  className: 'header-button',
                  imgUrl: _ctx.loadIconDevis,
                  onClick: _ctx.goDevis,
                  title: _ctx.$t('header.estimate.request.button'),
                  class: "bandeau-button"
                }, null, 8, ["imgUrl", "onClick", "title"]),
                _createVNode(_component_ReglePastille, { cle: "menuCompte.boutonDemanderDevis" })
              ]))
            : _createCommentVNode("", true),
          (_ctx.connected && _ctx.checkDroitSubRoute('creer.demande') && _ctx.isPortailClient)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                _createVNode(_component_BorderedIconButton, {
                  id: "bouton-demande-intervention",
                  className: 'header-button',
                  imgUrl: _ctx.loadIconIntervention,
                  onClick: _ctx.goIntervention,
                  title: _ctx.$t('header.intervention.request.button'),
                  class: "bandeau-button"
                }, null, 8, ["imgUrl", "onClick", "title"]),
                _createVNode(_component_ReglePastille, { cle: "menuCompte.boutonDemandeIntervention" })
              ]))
            : _createCommentVNode("", true),
          (_ctx.connected)
            ? (_openBlock(), _createElementBlock("button", {
                key: 4,
                id: "bouton-mon-compte",
                "aria-expanded": _ctx.showMyAccountMenu,
                "aria-label": _ctx.$t('modale.my.account.title'),
                "aria-haspopup": "true",
                class: "container-my-account",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openNav && _ctx.openNav(...args)))
              }, [
                _createVNode(_component_RoundedIconAndText),
                _withDirectives(_createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.login), 1),
                    _createElementVNode("button", {
                      class: "dropdown-button disconnect",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.disconnect && _ctx.disconnect(...args)), ["stop"]))
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('app.disconnect')) + " ", 1),
                      _createVNode(_component_ReglePastille, {
                        cle: "menuCompte.deconnexion",
                        placement: "bottom"
                      })
                    ]),
                    (_ctx.isClient)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "dropdown-button options",
                          onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openOptionsSuiviModale && _ctx.openOptionsSuiviModale(...args)), ["stop"]))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.$t('modale.options.suivi.di.open')) + " ", 1),
                          _createVNode(_component_ReglePastille, {
                            cle: "menuCompte.optionsInterventions",
                            placement: "bottom"
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isClient)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "dropdown-button options",
                          onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openPreavisInterventionModale && _ctx.openPreavisInterventionModale(...args)), ["stop"]))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.$t('modale.preavisIntervention.open')) + " ", 1),
                          _createVNode(_component_ReglePastille, {
                            cle: "menuCompte.preavisIntervention",
                            placement: "bottom"
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "dropdown-button options",
                      onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openMonCompteModale && _ctx.openMonCompteModale(...args)), ["stop"]))
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('modale.my.account.title')) + " ", 1),
                      _createVNode(_component_ReglePastille, {
                        cle: "menuCompte.monCompte",
                        placement: "bottom"
                      })
                    ])
                  ])
                ], 512), [
                  [_vShow, _ctx.showMyAccountMenu]
                ])
              ], 8, _hoisted_12))
            : _createCommentVNode("", true),
          (_ctx.connected)
            ? (_openBlock(), _createElementBlock("img", {
                key: 5,
                alt: _ctx.$t('alt.drapeau.langue'),
                src: _ctx.getImageDrapeauLangueSelectionnee,
                class: "height-20px margin-left-10px"
              }, null, 8, _hoisted_16))
            : _createCommentVNode("", true),
          (_ctx.connected)
            ? (_openBlock(), _createElementBlock("button", {
                key: 6,
                "aria-expanded": _ctx.modaleChoixLangueOuverte,
                "aria-label": _ctx.$t('aria.modale.choix.langue'),
                "aria-haspopup": "true",
                class: "language-button",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.ouvrirFermerModaleChoixLangue && _ctx.ouvrirFermerModaleChoixLangue(...args)))
              }, [
                (!_ctx.modaleChoixLangueOuverte)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      alt: _ctx.$t('alt.ouverture.menu.langues'),
                      src: _ctx.getArrowDown
                    }, null, 8, _hoisted_18))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      alt: _ctx.$t('alt.fermeture.menu.langues'),
                      src: _ctx.getArrowUp
                    }, null, 8, _hoisted_19))
              ], 8, _hoisted_17))
            : _createCommentVNode("", true),
          (_ctx.modaleChoixLangueOuverte)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getLanguesdisponibles, (langue) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: langue,
                    class: "cursor-pointer language-item",
                    onClick: ($event: any) => (_ctx.setLangue(langue.id))
                  }, [
                    _createTextVNode(_toDisplayString(langue.langue) + " ", 1),
                    _createElementVNode("span", _hoisted_22, [
                      _createElementVNode("img", {
                        alt: _ctx.$t('alt.changer.langue', { langue: langue.langue }),
                        src: _ctx.getImageDrapeauLangue(langue.id),
                        class: "height-20px width-30px margin-top-0 margin-10px language-flag"
                      }, null, 8, _hoisted_23)
                    ])
                  ], 8, _hoisted_21))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.isModaleOptionsSuiviOpen)
        ? (_openBlock(), _createBlock(_component_OptionSuiviModale, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.isModalePreavisOpen)
        ? (_openBlock(), _createBlock(_component_PreavisInterventionModale, { key: 1 }))
        : _createCommentVNode("", true),
      (_ctx.isModaleMonCompteOpen)
        ? (_openBlock(), _createBlock(_component_MonCompteModale, { key: 2 }))
        : _createCommentVNode("", true),
      (_ctx.isModaleAppInfoOpen)
        ? (_openBlock(), _createBlock(_component_AppInfoModale, {
            key: 3,
            onCancel: _ctx.closeAppInfoModale
          }, null, 8, ["onCancel"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}